import { computed } from "vue";
import { useContractCreateStore } from "../contract-create-store";
import type { IOrderSummaryComponentObject } from "nlb-buy-go-library";

export function useOrderSummaryData() {
    const contractCreateStore = useContractCreateStore();

    const OrderSummaryData = computed<IOrderSummaryComponentObject>({
            get: () => ({
                flowType: contractCreateStore.AppState.ProcessData.flowType,
                storeUrl: contractCreateStore.AppState.WebOrderData.storeUrl,
                storeName: contractCreateStore.AppState.WebOrderData.storeName,
                creditAmount: contractCreateStore.AppState.ContractData.creditAmount
            }),
            
            set: (newValues: IOrderSummaryComponentObject) => {
                contractCreateStore.AppState.ProcessData.flowType = newValues.flowType;
                contractCreateStore.AppState.WebOrderData.storeUrl = newValues.storeUrl;
                contractCreateStore.AppState.WebOrderData.storeName = newValues.storeName;
                contractCreateStore.AppState.ContractData.creditAmount = newValues.creditAmount;
            }
        });
    return { OrderSummaryData };
}
